import { alertStyle } from './shared-styles-from-theme-fluent';

export const getInlineDownloadStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .inline-download-form, & .inlinereportdownload-panel': {
    '& .dropdown-toggle': {
      minWidth: '180px',
      border: `1px solid ${palette.neutralSecondary}`,
      paddingLeft: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      paddingRight: '0',
      alignItems: 'center',
      fontWeight: 'normal',
      '& .caret': {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    },
    '& .inline-download-start-time-editor, & .inline-download-end-time-editor': {
      width: 180,
    },
    '& .form-group > label': {
      textAlign: 'left',
      width: '100%',
      paddingLeft: '0',
      paddingBottom: '8px',
    },
    '& .form-group > div': {
      paddingLeft: '0',
    },
    '& .btn+.btn': {
      marginLeft: '7px',
    },
    ...alertStyle({ palette }),
  },
  '& .inline-download-form': {
    '& .checkbox input[type="checkbox"]': {
      float: 'left',
    },
    '& .inline-download-form__save-as-custom-report input[type=text]': {
      height: 32,
      width: 180,
      paddingLeft: 8,
      marginBottom: 2,
    },
    '& .checkbox > label :nth-child(n+3)': {
      marginLeft: '8px',
    },
    '& .inline-download-email-frequency-editor': {
      paddingLeft: '28px',
    },
    '& .iconba-Forward': {
      color: palette.white,
      backgroundColor: palette.themeDark,
    },
    '& .email-notification-delivery-option-editor__search-box': {
      marginBottom: '5px',
    },
    '& .email-notification-delivery-option-editor__user-list': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: '10px',
      overflowY: 'auto',
      maxHeight: '300px',
    },
    '& .inline-download-cron-editor': {
      display: 'flex',
      whiteSpace: 'pre',
      alignItems: 'center',

      '& .dropdown-menu': {
        overflow: 'auto',
        maxHeight: 360,
      },
    },
    '& .segment-row': {
      '&:first-child': {
        marginBottom: '5px',
      },
    },
    '& .add-target': {
      border: 'none',
      color: '#1470A5',
      background: 'none',
      padding: '0px',
      '&:hover': {
        color: '#0c4261',
      },
    },
    '& .add_icon': {
      fontFamily: iconFontFamily,
      fontSize: 12,
      marginRight: 5,
      '&:before': {
        content: '"\\E710"',
      },
    },
    '& .glyphicon-remove': {
      fontFamily: iconFontFamily,
      fontSize: 14,
      fontWeight: 'normal',
      '&:before': {
        content: '"\\E711"',
      },
    },
  },
  '& .inlinereportdownload-panel': {
    '& .icon-arrowdown-normal': {
      color: palette.neutralSecondary,
      fontFamily: iconFontFamily,
      fontSize: 12,
      fontWeight: 'normal',
      margin: '0 4px',
      padding: '0 4px',
      '&:before': {
        content: '"\\E70D"',
      },
    },
  },
});
